export default function negativeDirective() {
  return {
    restrict: 'A',
    scope: {
      negative: '='
    },
    link: function (scope, element) {
      if (parseFloat(scope.negative) < 0) {
        element.addClass('red');
      }
    }
  };
}
